import { Injectable } from '@angular/core';
import { FinancialApiService } from 'src/app/revenue/shared/financial-api.service';
import { PagedResultGeneric } from 'src/app/shared';
import { PledgeCampaignTypeSearchDto } from './dto/pledge-campaign-type-search.dto';
import { PledgeCampaignTypeDto } from './dto/pledge-campaign-type.dto';
@Injectable({
  providedIn: 'root',
})
export class PledgeCampaignTypeService {
  public constructor(private _apiService: FinancialApiService) {}

  public searchPledgeCampaignTypes(seachParams: PledgeCampaignTypeSearchDto): Promise<PagedResultGeneric<PledgeCampaignTypeDto>> {
    return this._apiService.post('/financial/v2/pledgecampaigntype/search', seachParams);
  }

  public getPledgeCampaignType(campaignTypeId: number) {
    return this._apiService.get(`/financial/v2/pledgecampaigntype/${campaignTypeId}`);
  }

  public createPledgeCampaignType(campaignType: PledgeCampaignTypeDto) {
    return this._apiService.post('/financial/v2/pledgecampaigntype', campaignType);
  }

  public updatePledgeCampaignType(campaignType: PledgeCampaignTypeDto) {
    return this._apiService.put(`/financial/v2/pledgecampaigntype`, campaignType);
  }

  public deletePledgeCampaignType(campaignTypeId: number) {
    return this._apiService.delete(`/financial/v2/pledgecampaigntype/${campaignTypeId}`);
  }
}
